import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clientUpdateById,
  signin,
} from "../../redux/authentication/AuthenticationSlice";
import { FaChevronLeft } from "react-icons/fa";

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginData, clientid, updateClientLoading } = useSelector(
    (state) => state.Authentication
  );

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  // Initialize form when data available
  useEffect(() => {
    if (loginData) {
      setFormData({
        name: loginData?.Name || "",
        email: loginData?.Email || "",
        mobile: loginData?.Mobile || "",
      });
    }
  }, [loginData]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      alert("Error: Please enter your name");
      return;
    }

    if (!formData.email.trim()) {
      alert("Error: Please enter your email");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("Error: Please enter a valid email address");
      return;
    }

    const updateData = {
      _id: loginData?._id || clientid,
      Name: formData.name,
      Email: formData.email,
    };

    try {
      const response = await dispatch(clientUpdateById(updateData)).unwrap();
      const updatedClient = response?.client;

      if (updatedClient?._id) {
        const updatedUser = {
          ...loginData,
          ...updatedClient,
        };
        dispatch(signin(updatedUser));
        alert("Success: Profile updated successfully");
        navigate("/profile");
      } else {
        alert("Error: Update failed, please try again");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Error: Failed to update profile");
    }
  };

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ marginTop: "80px", backgroundColor: "#f8f9fa" }}
    >
      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center px-2 rounded-1 py-2 shadow-sm mb-3"
        style={{ backgroundColor: "#aa2b57" }}
      >
        <button
          className="btn btn-light btn-sm"
          onClick={() => navigate(-1)}
          style={{ minWidth: "40px" }}
        >
          <FaChevronLeft />
        </button>
        <h1
          className="text-white fs-6 fw-semibold m-0 text-center flex-grow-1"
          style={{ letterSpacing: "0.5px" }}
        >
          Profile
        </h1>
      </div>

      {/* ================= FORM SECTION ================= */}
      <div className="container mt-4">
        <div className="row g-4">
          {/* Full Name */}
          <div className="col-12 col-md-4">
            <label
              className="form-label fw-semibold mb-2 d-flex align-items-center"
              style={{ color: "#374151", fontSize: "0.9375rem" }}
            >
              <i className="bi bi-person me-2" style={{ color: "#aa2b57" }}></i>
              Full Name
            </label>

            <div
              className="input-group border rounded-3 overflow-hidden"
              style={{ borderColor: "#E5E7EB" }}
            >
              <input
                type="text"
                className="form-control border-0 shadow-none"
                style={{
                  padding: "0.875rem 1rem",
                  color: "#111827",
                  fontWeight: "500",
                  fontSize: "0.9375rem",
                }}
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
                placeholder="Enter your full name"
              />
            </div>
          </div>

          {/* Email */}
          <div className="col-12 col-md-4">
            <label
              className="form-label fw-semibold mb-2 d-flex align-items-center"
              style={{ color: "#374151", fontSize: "0.9375rem" }}
            >
              <i
                className="bi bi-envelope me-2"
                style={{ color: "#aa2b57" }}
              ></i>
              Email Address
            </label>

            <div
              className="input-group border rounded-3 overflow-hidden"
              style={{ borderColor: "#E5E7EB" }}
            >
              <input
                type="email"
                className="form-control border-0 shadow-none"
                style={{
                  padding: "0.875rem 1rem",
                  color: "#111827",
                  fontWeight: "500",
                  fontSize: "0.9375rem",
                }}
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="Enter your email"
                autoCapitalize="none"
              />
            </div>
          </div>

          {/* Mobile */}
          <div className="col-12 col-md-4">
            <label
              className="form-label fw-semibold mb-2 d-flex align-items-center"
              style={{ color: "#374151", fontSize: "0.9375rem" }}
            >
              <i className="bi bi-phone me-2" style={{ color: "#aa2b57" }}></i>
              Mobile Number
            </label>

            <div
              className="input-group border rounded-3 overflow-hidden bg-light"
              style={{ borderColor: "#D1D5DB" }}
            >
              <span
                className="input-group-text border-0 bg-transparent"
                style={{ color: "#6B7280", fontSize: "0.9375rem" }}
              >
                <i className="bi bi-lock"></i>
              </span>

              <input
                type="text"
                className="form-control border-0 shadow-none bg-transparent"
                style={{
                  padding: "0.875rem 1rem",
                  color: "#6B7280",
                  fontWeight: "500",
                  fontSize: "0.9375rem",
                }}
                value={formData.mobile}
                readOnly
              />
            </div>

            <div className="d-flex align-items-center mt-2">
              <i
                className="bi bi-info-circle text-muted me-2"
                style={{ fontSize: "0.875rem" }}
              ></i>
              <p
                className="text-muted small m-0"
                style={{ fontSize: "0.8125rem" }}
              >
                Mobile number cannot be changed for security reasons
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ================= SUBMIT ================= */}
      <div
        className="p-2 bg-white border-top mt-auto justify-content-end d-flex"
        style={{ borderColor: "#e9ecef" }}
      >
        <button
          className="btn d-flex align-items-center justify-content-center py-2 rounded-3"
          onClick={handleSubmit}
          disabled={updateClientLoading}
          style={{
            backgroundColor: "#aa2b57",
            color: "#fff",
            fontSize: "1rem",
            fontWeight: "600",
            letterSpacing: "0.3px",
            transition: "all 0.3s",
            border: "none",
          }}
        >
          {updateClientLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                style={{ fontSize: "12px" }}
              ></span>
              <span>Updating Profile...</span>
            </>
          ) : (
            <>
              <i
                className="bi bi-check-circle me-2 px-2"
                style={{ fontSize: "10px" }}
              ></i>
              Update Profile
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default EditProfile;
